import { configuratorBuilder } from 'element-domain'
import { TEXTURES_URLS } from 'element-domain/src/data/texture-data'
import { createI18n } from 'element-i18n'

import { adminComponents, adminElements } from './admin/components.js'
import NotAuthorizedAdminPage from './admin/ui/NotAuthorizedAdminPage.js'
import { tableComponents } from './entity-components/table'
import AppEnvironment from './scene/AppEnvironment'
import { TextureProcessingMap } from './systems/resources'
import {
  baseFourLegMustHaveApronsTransformer,
  baseStyleNotAvailableForThisTopLengthTransformer,
  baseStyleNotAvailableForThisTopTransformer,
  baseTypeChangedTransformer,
  baseTypeMustHaveStylesTransformer,
  deselectOnEntityCreationTransformer,
  deselectTransformer,
  leafAmountNotAvailableForThisLeafTypeModifiedTransformer,
  lengthTooShortForDoubleBaseTransformer,
  seatingAmountNotAvailableForThisSeatingTypeModifiedTransformer,
  switchingEdgeStyleUnroundsCornersTransformer,
  thicknessNotAvailableForThisTopModifiedTransformer,
  topWithDiameterLengthTooShortForPerimeterOrDropInLeafTransformer,
  topWithWidthAndLengthLengthTooShortForPerimeterOrDropInLeafTransformer,
} from './systems/transformers'
import { elementTheme } from './ui/theme'

const config = configuratorBuilder
  .withComponentOptics([...tableComponents])
  .withAdminComponentOptics(adminComponents)
  .withElements([AppEnvironment, NotAuthorizedAdminPage, ...adminElements])
  .withTheme(elementTheme)
  .withI18n(createI18n())
  .withTransformers(
    [
      { name: 'deselectTransformer', transformer: deselectTransformer },
      { name: 'deselectOnEntityCreationTransformer', transformer: deselectOnEntityCreationTransformer },
      {
        name: 'thicknessNotAvailableForThisTopModifiedTransformer',
        transformer: thicknessNotAvailableForThisTopModifiedTransformer,
      },
      { name: 'baseTypeChangedTransformer', transformer: baseTypeChangedTransformer },
      { name: 'baseStyleNotAvailableForThisTopTransformer', transformer: baseStyleNotAvailableForThisTopTransformer },
      {
        name: 'baseStyleNotAvailableForThisTopLengthTransformer',
        transformer: baseStyleNotAvailableForThisTopLengthTransformer,
      },
      {
        name: 'leafAmountNotAvailableForThisLeafTypeModifiedTransformer',
        transformer: leafAmountNotAvailableForThisLeafTypeModifiedTransformer,
      },
      {
        name: 'seatingAmountNotAvailableForThisSeatingTypeModifiedTransformer',
        transformer: seatingAmountNotAvailableForThisSeatingTypeModifiedTransformer,
      },
      { name: 'lengthTooShortForDoubleBaseTransformer', transformer: lengthTooShortForDoubleBaseTransformer },
      {
        name: 'topWithWidthAndLengthLengthTooShortForPerimeterOrDropInLeafTransformer',
        transformer: topWithWidthAndLengthLengthTooShortForPerimeterOrDropInLeafTransformer,
      },
      {
        name: 'topWithDiameterLengthTooShortForPerimeterOrDropInLeafTransformer',
        transformer: topWithDiameterLengthTooShortForPerimeterOrDropInLeafTransformer,
      },
      {
        name: 'baseFourLegMustHaveApronsTransformer',
        transformer: baseFourLegMustHaveApronsTransformer,
      },
      {
        name: 'baseTypeMustHaveStylesTransformer',
        transformer: baseTypeMustHaveStylesTransformer,
      },
      {
        name: 'switchingEdgeStyleUnroundsCornersTransformer',
        transformer: switchingEdgeStyleUnroundsCornersTransformer,
      },
    ],
    [
      { name: 'deselect', priority: Infinity },
      { name: 'deselect-on-entity-creation', priority: Infinity },
      { name: 'thickness-not-available-for-this-top-modified', priority: Infinity },
      { name: 'base-type-changed', priority: Infinity },
      { name: 'base-style-not-available-for-this-top', priority: Infinity },
      { name: 'length-too-short-for-double-base', priority: Infinity },
      { name: 'base-style-not-available-for-this-top-length', priority: Infinity },
      { name: 'leaf-amount-not-available-for-this-leaf-type-modified', priority: Infinity },
      { name: 'seating-amount-not-available-for-this-seating-type-modified', priority: Infinity },
      { name: 'top-with-width-and-length-length-too-short-for-perimeter-or-drop-in-leaf', priority: Infinity },
      { name: 'top-with-diameter-length-too-short-for-perimeter-or-drop-in-leaf', priority: Infinity },
      { name: 'base-four-leg-must-have-aprons', priority: Infinity },
      { name: 'base-type-must-have-styles', priority: Infinity },
      { name: 'switching-edge-style-unrounds-corners', priority: Infinity },
    ]
  )
  .withDefaultEnvs({
    deploymentId: phoenix.runtimeConfig.DEPLOYMENT_ID,
    datadogEnabled: phoenix.runtimeConfig.DATADOG_ENABLED,
    datadogSite: phoenix.runtimeConfig.DATADOG_SITE,
    datadogClientToken: phoenix.runtimeConfig.DATADOG_CLIENT_TOKEN,
    serviceName: phoenix.runtimeConfig.SERVICE_NAME,
    persistenceMode: phoenix.runtimeConfig.PERSISTENCE_MODE,
    serverUrl: phoenix.runtimeConfig.SERVER_URL,
    resourcesUrl: phoenix.runtimeConfig.RESOURCES_URL,
    gtmId: phoenix.runtimeConfig.GTM_ID,
    gtmDebug: phoenix.runtimeConfig.GTM_DEBUG,
  })
  .withResourcesConfig({
    prefetchTextureUrls: TEXTURES_URLS,
    textureProcessingMap: TextureProcessingMap,
  })
  .buildConfig()

export default config
